import { PHONEME_PHRASE_TYPES } from "../../constants/readerConfigConstants";

export function shouldEnablePhonemePlacement(story, overallPhraseIndex) {
  return PHONEME_PHRASE_TYPES.includes(story?.items?.[overallPhraseIndex]?.type);
}
